export const dataHooks = {
  app: {
    root: 'appRootDataHook',
    header: 'appRootHeader',
    backBtn: 'app.backButton',
    // The wrapper around the above-dialog back button, and the white card
    // itself. Both exist so a preset can position them from App.scss without
    // reaching for a CSS-module class name, which is hashed at build time.
    backBtnAboveDialog: 'app.backButtonAboveDialog',
    bodyContainer: 'app.bodyContainer',
  },
  sso: {
    enterEmailDialog: {
      container: 'ssoEnterEmailDialog',
      emailInput: 'ssoEnterEmailDialogEmailInput',
      submitButton: 'ssoEnterEmailDialogSubmitButton',
    },
    emailAlreadyExistDialog: {
      container: 'emailAlreadyExistDialog',
    },
    mainDialog: {
      container: 'mainSsoDialog',
      title: 'mainSsoDialog.title',
      submitButton: 'mainSsoDialog.submitButton',
    },
  },
  dialogHeader: {
    container: 'dialogHeaderContainer',
    title: 'dialogHeaderTitle',
    backButton: 'dialogHeaderBackButton',
  },
  mainHeader: {
    container: 'mainHeaderContainer',
  },
  modalHeader: {
    container: 'modalHeaderContainer',
  },
  inputField: {
    default: 'inputField',
    visibilityIcon: 'inputField.visibilityIcon',
  },
  logo: {
    default: 'logoSvg',
  },
  approveAndContinueDialog: {
    container: 'approveAndContinueDialog',
    title: 'approveAndContinueDialog.title',
  },
  blockedAccountDialog: {
    container: 'blockedAccountDialog',
  },
  selectAccountDialog: {
    container: 'selectAccountDialog',
  },
  selectWorkspaceDialog: {
    container: 'selectWorkspaceDialog',
  },
  emailStep: {
    container: 'emailStepDialog',
    header: 'emailStep.header',
    title: 'emailStep.title',
    emailInput: 'emailStep.emailInput',
    submitButton: 'emailStep.submitButton',
    forgotEmailLink: 'emailStep.forgotEmailLink',
    continueToSsoLink: 'emailStep.continueToSsoLink',
  },
  login: {
    container: 'loginDialog',
    emailInput: 'login.emailInput',
    changeEmail: 'login.changeEmail',
    passwordInput: 'login.passwordInput',
    submitButton: 'login.submitButton',
    header: 'login.header',
    title: 'login.title',
    subtitle: 'login.subtitle',
    presetSubtitle: 'login.presetSubtitle',
    resendPopover: 'login.resend.popover',
    switchToSignupBtn: 'signup.switchToSignupBtn',
    forgotPassword: 'login.forgotPassword',
    loginWithEmailCode: 'login.loginWithEmailCode',
  },
  signup: {
    container: 'signupDialog',
    header: 'signup.header',
    title: 'signup.title',
    subtitle: 'signup.subtitle',
    presetSubtitle: 'signup.presetSubtitle',
    email: 'signup.email',
    confirmEmail: 'signup.confirmEmail',
    password: 'signup.password',
    confirmPassword: 'sigup.confirmPassword',
    submit: 'signup.submit',
    switchToLoginBtn: 'signup.switchToLoginBtn',
    signupWithEmailCode: 'signup.signupWithEmailCode',
  },
  enterCode: {
    container: 'enterCodeDialog',
    codeInput: 'enterCodeDialogCodeInput',
    verifyButton: 'enterCodeDialogVerifyButton',
    resendButton: 'enterCodeDialogResendButton',
    closeButton: 'enterCodeDialogCloseButton',
    verifyAnotherWay: 'enterCodeDialogVerifyAnotherWay',
  },
  twoFaLobby: {
    container: 'twoFaLobbyDialog',
    method: (key: string) => `twoFaLobbyMethod-${key}`,
    methodError: (key: string) => `twoFaLobbyMethodError-${key}`,
  },
  resetPassword: {
    container: 'resetPassword.container',
    password: 'resetPassword.passwordField',
    rePassword: 'resetPassword.rePasswordField',
  },
  resetPasswordConfirmation: {
    container: 'resetPasswordConfirmation.container',
  },
  resetPasswordInvalid: {
    container: 'resetPasswordInvalid.container',
    actionLink: 'resetPasswordInvalid.actionLink',
    notification: 'resetPasswordInvalid.notification',
  },
  emailVerificationResult: {
    container: 'emailVerificationResult.container',
    homeButton: 'emailVerificationResult.homeButton',
    resendButton: 'emailVerificationResult.resendButton',
    loginButton: 'emailVerificationResult.loginButton',
  },
  enterPassword: {
    container: 'enterPassword.container',
    password: 'enterPassword.passwordField',
    submitButton: 'enterPassword.submitButton',
  },
  accountVerification: {
    container: 'accountVerification.container',
  },
  enterEmailForSocial: {
    container: 'enterEmailForSocial.container',
  },
  postLogin: {
    common: {
      modalContainer: 'postLogin.modalContainer',
      header: 'postLogin.ConfirmDetails.header',
      sideActionTextButton: 'postLogin.sideActionTextButton',
      accountSettingsTextButton: 'postLogin.accountSettingsTextButton',
      verifyCodeContainer: 'postLogin.verifyCodeContainer',
      skip: 'postLogin.skip',
    },
    confirmEmail: {
      email: 'postLogin.ConfirmDetails.email',
      changeEmailLink: 'postLogin.ConfirmDetails.changeEmailLink',
    },
    confirmDetails: {
      editEmailButton: 'postLogin.confirmDetails.editLinkButton',
    },
    changeAccountEmail: {
      emailInput: 'postLogin.changeAccountEmail.emailInput',
      confirmEmailInput: 'postLogin.changeAccountEmail.confirmEmailInput',
    },
    passkeyEnroll: {
      errorMessage: 'postLogin.passkeyEnroll.errorMessage',
      button: 'postLogin.passkeyEnroll.button',
      learnMore: 'postLogin.passkeyEnroll.learnMore',
      howItWorks: 'postLogin.passkeyEnroll.howItWorks',
      passwordFallbackHint: 'postLogin.passkeyEnroll.passwordFallbackHint',
    },
  },
  floatingNotification: {
    main: 'mainFloatingNotification',
  },
  policiesSection: {
    container: 'policiesSection.container',
    minimalContent: 'policiesSection.minimal.content',
    expandedContent: 'policiesSection.expanded.content',
    recaptchaSection: 'policiesSection.recaptcha',
  },
  loadingDialog: {
    container: 'loadingDialog.container',
  },
  deviceLogin: {
    container: 'deviceLoginDialog',
    title: 'deviceLoginTitle',
    bodyContent: 'deviceLoginBodyContent',
    codeInput: 'deviceLoginCodeInput',
    footerContent: 'deviceLoginBodyFooter',
    connect: 'deviceLoginConnectCta',
    anotherAccountCta: 'deviceLoginAnotherAccountCta',
  },
  deviceAuthorize: {
    container: 'deviceAuthorizeDialog',
    title: 'deviceAuthorizeTitle',
    subtitle: 'deviceAuthorizeSubtitle',
    qrCode: 'deviceAuthorizeQrCode',
    userCode: 'deviceAuthorizeUserCode',
    waiting: 'deviceAuthorizeWaiting',
    error: 'deviceAuthorizeError',
    retry: 'deviceAuthorizeRetryCta',
    regularSignin: 'deviceAuthorizeRegularSigninCta',
    footer: 'deviceAuthorizeFooter',
    steps: 'deviceAuthorizeSteps',
  },
  posDeviceLogin: {
    container: 'posDeviceLoginDialog',
    title: 'posDeviceLoginTitle',
    bodyContent: 'posDeviceLoginBodyContent',
    codeInput: 'posDeviceLoginCodeInput',
    footerContent: 'posDeviceLoginBodyFooter',
    connect: 'posDeviceLoginConnectCta',
    anotherAccountCta: 'posDeviceLoginAnotherAccountCta',
  },
  connectionSuccessful: {
    title: 'connectionSuccessful.Title',
    disconnect: 'connectionSuccessful.Disconnect',
  },
  posDeviceConnectionSuccessful: {
    title: 'posDeviceConnectionSuccessful.Title',
    disconnect: 'posDeviceConnectionSuccessful.Disconnect',
  },
  web5DeviceLogin: {
    container: 'web5DeviceLoginDialog',
    title: 'web5DeviceLoginTitle',
    bodyContent: 'web5DeviceLoginBodyContent',
    codeInput: 'web5DeviceLoginCodeInput',
    footerContent: 'web5DeviceLoginBodyFooter',
    connect: 'web5DeviceLoginConnectCta',
    anotherAccountCta: 'web5DeviceLoginAnotherAccountCta',
  },
  web5DeviceConnectionSuccessful: {
    container: 'web5DeviceConnectionSuccessfulDialog',
    title: 'web5DeviceConnectionSuccessful.Title',
    disconnect: 'web5DeviceConnectionSuccessful.Disconnect',
  },
  disconnectSuccessful: {
    title: 'disconnectSuccessful.Title',
    customerCareLink: 'disconnectSuccessful.customerCareLink',
  },
  socials: {
    googleBtn: 'socials.googleBtn',
    facebookBtn: 'socials.facebookBtn',
    appleBtn: 'socials.appleBtn',
    googleIcon: 'socials.googleIcon',
    facebookIcon: 'socials.facebookIcon',
    appleIcon: 'socials.appleIcon',
    qrScanButton: 'socials.qrScanButton',
    googleInAppBrowserNotice: 'socials.googleInAppBrowserNotice',
    googleInAppBrowserNoticeCta: 'socials.googleInAppBrowserNoticeCta',
  },
  lastUsedBadge: {
    badge: 'lastUsedBadge.badge',
  },
  loginEmailStep: {
    switchToSignupBtn: 'loginEmailStep.switchToSignupBtn',
  },
  ownerAppModal: {
    main: 'ownerAppModal',
    options: 'ownerAppModal.options',
    deviceName: 'ownerAppModal.deviceName',
  },
};
